import { render, staticRenderFns } from "./kuaishou_portrait.vue?vue&type=template&id=86d6f246&scoped=true"
import script from "./kuaishou_portrait.vue?vue&type=script&lang=js"
export * from "./kuaishou_portrait.vue?vue&type=script&lang=js"
import style0 from "./kuaishou_portrait.vue?vue&type=style&index=0&id=86d6f246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d6f246",
  null
  
)

export default component.exports